// @flow
import type { AlertState } from './index'
import type { AlertMessage } from '../../../types/alert-message'

export default {

  getViewableAlertNotificationMessages: (state: AlertState): AlertMessage[] => {
    return state.alert.messages.filter(alertMessage => !alertMessage.viewed)
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/alert/getters.js